import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-signed-out',
  imports: [],
  templateUrl: './signed-out.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './signed-out.component.scss',
})
export class SignedOutComponent {}
